// Look of the sign-in forms (login, sign-up), shared so they stay alike. Same recipe as StarkBoard's
// (components/auth/auth-styles.ts there), with green instead of blue. The card lies directly on the backdrop of
// AuthShell: translucent, blurred, accent color in border and glow. Inputs and the main button are larger than in
// the app: these pages are mostly used on a phone.

export const AUTH_CARD = [
  "rounded-2xl bg-neutral-950/75 ring-1 ring-emerald-500/25 backdrop-blur-md",
  "shadow-[0_30px_80px_-20px_rgba(16,185,129,0.3)]",
  "[--card-spacing:--spacing(6)] sm:[--card-spacing:--spacing(8)]",
  // fields: 48 px high, 16 px text (no zoom on iOS), green focus
  "[&_input]:h-12 [&_input]:rounded-xl [&_input]:bg-white/[0.04] [&_input]:text-base md:[&_input]:text-base",
  "[&_input:focus-visible]:border-emerald-500 [&_input:focus-visible]:ring-emerald-500/25",
].join(" ")

export const AUTH_TITLE = "text-2xl font-semibold"

export const AUTH_SUBMIT =
  "h-12 rounded-xl bg-emerald-600 text-base text-white hover:bg-emerald-500 focus-visible:ring-emerald-500/40"

export const AUTH_SECONDARY = "h-12 rounded-xl text-base"

export const AUTH_LINK =
  "text-sm text-emerald-300 underline-offset-4 hover:text-emerald-200 hover:underline"
